import { makeStyles, createStyles } from '@material-ui/core';

export const useSearchInputStyle = makeStyles((theme) =>
  createStyles({
    focused: {},
    input: {
      color: '#333',
      fontFamily: ['SansOri', 'Arial', 'Helvetica', 'sans-serif'].join(','),
      fontSize: '14px',
      lineHeight: 1,
      padding: '12.5px 0',
      width: '100%',
      boxShadow: 'inset 0 0 0 1000px #f5f5f5!important',
      textFillColor: '#333',
    },
    root: {
      [theme.breakpoints.up('md')]: {
        width: '600px',
      },
      [theme.breakpoints.down('md')]: {
        width: '600px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      backgroundColor: '#f5f5f5',
      border: '2px solid #f5f5f5',
      borderRadius: '22.5px',

      '&$focused': {
        borderBottomColor: '#f5f5f5', // theme override
        backgroundColor: '#f5f5f5 !important',
      },
    },
  }),
);
